import { ProposalsProps } from 'lib/types'
import { useProposalGenericData } from './ProposalGenericInitialization'
import ProposalTable from './ProposalTable'
import './proposal.scss'

const ProposalGeneric = ({ proposals }: IProps) => {

    const {
        recordingServerSpecificationTableBody,
        netWorkInterfaceTableBody,
        liveDatabaseStorageTableBody,
        hasArchiving,
        archivingDatabaseStorageTableBody
    } = useProposalGenericData(proposals)    

    return (
        <div className="my-8 py-4">
            <div className="msds-text-header-3 py-2">Recording server</div>
            <div className="row">
                <div className="col-6">
                    <ProposalTable
                        title="recording server specification"
                        head={['quantity', 'machine type', 'cpu type', 'os disk', 'ram']}
                        body={[recordingServerSpecificationTableBody]}
                    />
                </div>
                <div className="col-6">
                    <ProposalTable
                        title="network interface"
                        head={['usage', 'speed', 'required bitrate', 'details']}
                        body={netWorkInterfaceTableBody}
                    />
                </div>
                <div className="col-6">
                    <ProposalTable
                        title="live database storage information"
                        head={['quantity', 'disk type', 'disk size']}
                        body={[liveDatabaseStorageTableBody[0]]}
                        forceAlign={true}
                        tableInfoId="live-database-storage-information-table-1"
                    />
                    <ProposalTable
                        head={['raid type', 'Required Capacity', 'Formatted Capacity']}
                        body={[liveDatabaseStorageTableBody[1]]}
                        forceAlign={true}
                        tableInfoId="live-database-storage-information-table-2"
                    />
                    <ProposalTable
                        head={['connectivity', 'iops', 'mb/s']}
                        body={[liveDatabaseStorageTableBody[2]]}
                        forceAlign={true}
                        tableInfoId="live-database-storage-information-table-3"
                    />
                </div>
                <div className="col-6">
                    {hasArchiving && (
                        <>
                            <ProposalTable
                                title="archive database storage information"
                                head={['quantity', 'disk type', 'disk size']}
                                body={[archivingDatabaseStorageTableBody[0]]}
                                forceAlign={true}
                            />
                            <ProposalTable
                                head={['raid type', 'Required Capacity', 'Formatted Capacity']}
                                body={[archivingDatabaseStorageTableBody[1]]}
                                forceAlign={true}
                            />
                            <ProposalTable
                                head={['connectivity', 'iops', 'mb/s']}
                                body={[archivingDatabaseStorageTableBody[2]]}
                                forceAlign={true}
                            />
                        </>
                    )}
                </div>
            </div>            
        </div>
    )
}

interface IProps {
    proposals: ProposalsProps
}
export default ProposalGeneric
